import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';

// Questo componente protegge le rotte riservate agli utenti PUBBLICI
export const PublicRoute = ({ children }) => {
    const { currentUser: user, isInitialized } = useAppContext();
    const location = useLocation();
    const isAuthenticated = !!localStorage.getItem('token');

    if (!isInitialized && isAuthenticated) {
        // Se l'app sta ancora caricando la sessione e abbiamo un token, aspettiamo
        return null;
    }

    if (!user) {
        // Se non è loggato, reindirizza al login
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.userType !== 'PUBLIC') {
        // Se è un utente INTERNO, non può accedere. Reindirizza alla sua home page.
        return <Navigate to="/apps" replace />;
    }

    // Se è un utente PUBBLICO, mostra il contenuto
    return children;
};


// Questo componente protegge le rotte riservate agli utenti INTERNI
export const InternalRoute = ({ children }) => {
    const { currentUser: user, isInitialized } = useAppContext();
    const location = useLocation();
    const isAuthenticated = !!localStorage.getItem('token');

    if (!isInitialized && isAuthenticated) {
        // Se l'app sta ancora caricando la sessione e abbiamo un token, aspettiamo
        return null;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.userType === 'PUBLIC') {
        // Se è un utente PUBBLICO, non può accedere. Reindirizza alla sua dashboard.
        return <Navigate to="/my-dashboard" replace />;
    }

    // Se è un utente INTERNO, mostra il contenuto (il permesso specifico sarà poi gestito da PermissionRoute)
    return children;
};